import {
  FETCH_EXCHANGE_RATE,
  FETCH_PAYMENT_TRANSACTION,
  FETCH_TRANSACTIONS,
  FETCH_WALLET,
  INITIATE_BANK_TRANSFER,
  INITIATE_CARD_PAYMENT,
  INITIATE_CASHIA_WITHDRAWAL,
  INITIATE_MERCHANT_PAYMENT,
  INITIATE_STK_PUSH,
  TRANSFERS,
  WITHDRAW,
} from "_constants";
import { getClearActionType, reduxRequest } from "_helpers";
import { paymentService } from "_services";

export const fetchWallet = () => {
  return (dispatch) =>
    reduxRequest(dispatch, FETCH_WALLET, paymentService.fetchWallet());
};

export const clearWalletStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(FETCH_WALLET) });
};

export const fetchTransactions = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_TRANSACTIONS,
      paymentService.fetchTransactions()
    );
};

export const clearTransactionsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_TRANSACTIONS) });
};

export const initiateStkPush = (initiateStkPushDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      INITIATE_STK_PUSH,
      paymentService.initiateStkPush(initiateStkPushDetails)
    );
};

export const clearInitiateStkPushStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(INITIATE_STK_PUSH) });
};

export const withdraw = (withdrawDetails) => {
  return (dispatch) =>
    reduxRequest(dispatch, WITHDRAW, paymentService.withdraw(withdrawDetails));
};

export const clearWithdrawStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(WITHDRAW) });
};

export const fetchExchangeRate = (exchangeRateDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_EXCHANGE_RATE,
      paymentService.fetchExchangeRate(exchangeRateDetails)
    );
};

export const clearExchangeRateStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_EXCHANGE_RATE) });
};

export const transfers = (transfersDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      TRANSFERS,
      paymentService.transfers(transfersDetails)
    );
};

export const clearTransfersStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(TRANSFERS) });
};

export const initiateCardPayment = (initiateCardPaymentDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      INITIATE_CARD_PAYMENT,
      paymentService.initiateCardPayment(initiateCardPaymentDetails)
    );
};

export const clearInitiateCardPaymentStatusAndDetails = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(INITIATE_CARD_PAYMENT) });
};

export const initiateBankTransfer = (initiateBankTransferDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      INITIATE_BANK_TRANSFER,
      paymentService.initiateBankTransfer(initiateBankTransferDetails)
    );
};

export const clearInitiateBankTransferStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(INITIATE_BANK_TRANSFER) });
};

export const initiateMerchantPayment = (initiateMerchantPaymentDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      INITIATE_MERCHANT_PAYMENT,
      paymentService.initiateMerchantPayment(initiateMerchantPaymentDetails)
    );
};

export const clearInitiateMerchantPaymentStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(INITIATE_MERCHANT_PAYMENT) });
};

export const fetchPaymentTransaction = (uniqueRequestId) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_PAYMENT_TRANSACTION,
      paymentService.fetchPaymentTransaction(uniqueRequestId)
    );
};

export const clearFetchPaymentTransactionStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_PAYMENT_TRANSACTION) });
};

export const initiateCashiaWithdrawal = (initiateCashiaWithdrawalDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      INITIATE_CASHIA_WITHDRAWAL,
      paymentService.initiateCashiaWithdrawal(initiateCashiaWithdrawalDetails)
    );
};

export const clearInitiateCashiaWithdrawalStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(INITIATE_CASHIA_WITHDRAWAL) });
};
